import React from 'react';
import { Drawer, InputNumber, Input, Button, Form, Typography } from 'antd';
import { debtService, Debt } from '../../services/debtService';
import { DollarOutlined, ExclamationCircleOutlined } from '@ant-design/icons';

const { Text } = Typography;

interface Props {
  debt: Debt;
  onClose: () => void;
  onPaid: () => void;
  debts?: Debt[];
}

const DebtPaymentModalMobile: React.FC<Props> = ({ debt, onClose, onPaid, debts }) => {
  const [form] = Form.useForm();
  const [selectedDebtId, setSelectedDebtId] = React.useState<number>(debt.id);
  const debtList = debts && debts.length > 0 ? debts : [debt];
  const selectedDebt = debtList.find(d => d.id === selectedDebtId) || debt;
  const remain = selectedDebt.debt_amount - selectedDebt.paid_amount;

  React.useEffect(() => {
    if (debtList.length > 0 && !debtList.some(d => d.id === selectedDebtId)) {
      setSelectedDebtId(debtList[0].id);
    }
  }, [debtList, selectedDebtId]);

  const handleFinish = async (values: any) => {
    await debtService.createPayment(selectedDebt.id, values.amount, values.note);
    onPaid();
  };

  return (
    <Drawer
      open
      onClose={onClose}
      title={<div style={{ fontWeight: 700, fontSize: 17, textAlign: 'left' }}>Thanh toán công nợ</div>}
      placement="bottom"
      height="auto"
      bodyStyle={{ padding: 16, paddingBottom: 32 }}
      headerStyle={{ 
        borderBottom: '1px solid #f0f0f0',
        padding: '16px 16px 12px 16px'
      }}
      style={{ 
        borderTopLeftRadius: 16,
        borderTopRightRadius: 16
      }}
      maskStyle={{ backgroundColor: 'rgba(0, 0, 0, 0.45)' }}
    >
      {debtList.length > 1 && (
        <Form.Item label={<Text strong style={{ fontSize: 13 }}>Chọn khoản nợ</Text>} style={{ marginBottom: 12 }}>
          <select
            value={selectedDebtId}
            onChange={e => setSelectedDebtId(Number(e.target.value))}
            style={{ 
              width: '100%', 
              padding: 12, 
              borderRadius: 8, 
              border: '1px solid #d9d9d9', 
              fontSize: 14,
              backgroundColor: '#fff'
            }}
          >
            {debtList.map(d => (
              <option key={d.id} value={d.id}>
                Nợ #{d.id} - {d.debt_amount.toLocaleString('vi-VN')} VNĐ (Còn lại: {(d.debt_amount - d.paid_amount).toLocaleString('vi-VN')} VNĐ)
              </option>
            ))}
          </select>
        </Form.Item>
      )}
      <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 16 }}>
        <div style={{ textAlign: 'center', flex: 1 }}>
          <div style={{ fontSize: 12, color: '#888' }}>Còn lại</div>
          <div style={{ color: '#ff4d4f', fontWeight: 700, fontSize: 16 }}><ExclamationCircleOutlined /> {remain.toLocaleString('vi-VN')}</div>
        </div>
        <div style={{ textAlign: 'center', flex: 1 }}>
          <div style={{ fontSize: 12, color: '#888' }}>Số nợ ban đầu</div>
          <div style={{ color: '#faad14', fontWeight: 700, fontSize: 16 }}><DollarOutlined /> {selectedDebt.debt_amount.toLocaleString('vi-VN')}</div>
        </div>
      </div>
      <Form form={form} layout="vertical" onFinish={handleFinish} initialValues={{ amount: remain }}>
        <Form.Item label={<Text strong style={{ fontSize: 13 }}>Số tiền thanh toán</Text>} name="amount" rules={[{ required: true, message: 'Nhập số tiền!' }, { type: 'number', min: 1, max: remain, message: `Tối đa ${remain.toLocaleString('vi-VN')} VNĐ` }]}> 
          <InputNumber 
            min={1} 
            max={remain} 
            style={{ width: '100%', fontSize: 16, padding: 12 }} 
            addonAfter="VNĐ"
            inputMode="numeric"
            pattern="[0-9]*"
          />
        </Form.Item>
        <Form.Item label={<Text strong style={{ fontSize: 13 }}>Ghi chú</Text>} name="note">
          <Input.TextArea rows={3} maxLength={200} style={{ fontSize: 14 }} />
        </Form.Item>
        <Form.Item style={{ marginBottom: 0, marginTop: 24 }}>
          <Button type="primary" htmlType="submit" block size="large" style={{ fontWeight: 700, fontSize: 16, borderRadius: 8, height: 48 }}>Thanh toán</Button>
        </Form.Item>
      </Form>
    </Drawer>
  );
};

export default DebtPaymentModalMobile;
